import React from 'react'
import { LuUser } from 'react-icons/lu'
import { useNavigate } from 'react-router'

import SearchResultIcon from '@/components/misc/GlobalSearch/components/SearchResultIcon'
import SearchResultItem from '@/components/misc/GlobalSearch/components/SearchResultItem'
import { SEARCH_RESULT_ICON_COLORS } from '@/components/misc/GlobalSearch/constants'
import { useGlobalSearch } from '@/components/misc/GlobalSearch/hooks/useGlobalSearch'
import { CommandGroup } from '@/components/ui/command'
import { ROUTES } from '@/lib/routes'
import { ClientSearchResult } from '@/types/responses/companies'

interface Props {
  clients: ClientSearchResult[]
  /** Starting pop-in index, so clients animate in after the referrals. */
  indexOffset?: number
}

const ClientResults: React.FC<Props> = ({ clients, indexOffset = 0 }) => {
  const globalSearch = useGlobalSearch()
  const navigate = useNavigate()

  if (clients.length === 0) {
    return null
  }

  return (
    <CommandGroup heading="Clients">
      {clients.map((client, index) => (
        <SearchResultItem
          key={client['@id']}
          index={indexOffset + index}
          value={client['@id']}
          className="flex items-center gap-3"
          onSelect={() => {
            globalSearch.hide()
            // There's no page for a single client, so open the client list
            // filtered to this client. Filter by id rather than name, since
            // several clients can share a name.
            navigate(
              ROUTES.clients({
                searchParams: { clientId: client.id.toString() },
              }),
            )
          }}
        >
          <SearchResultIcon
            icon={LuUser}
            color={SEARCH_RESULT_ICON_COLORS.green}
          />

          {/* text */}
          <div className="flex flex-1 flex-col gap-0 items-stretch">
            <span className="font-medium">{client.fullNameAndPartyName}</span>

            {client.email && (
              <div className="text-muted-foreground text-xs">
                {client.email}
              </div>
            )}
          </div>
        </SearchResultItem>
      ))}
    </CommandGroup>
  )
}

export default ClientResults
